import Avatar from 'boring-avatars';
import { renderToStaticMarkup } from 'react-dom/server';

export function generateAvatarUrl(name: string | number = 'default') {
    const colors = ['#FF6347', '#6A5ACD', '#FFD700', '#7CFC00', '#1E90FF'];
    const avatarSVG = <Avatar size={64} name={String(name)} variant="beam" colors={colors} />;
    return `url("data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(avatarSVG))}")`;
}
